import { Dictionary } from './IAlert'
import { EventType } from './IEventEnums'
import { ReactNode } from 'react'

export interface CommunicationMessage {
  type: string
  headerText: ReactNode
  platform: string
  icon: ReactNode
  iconWhite?: ReactNode
  title: string
  message: string
  enabled: boolean
}

export enum PlatformType {
  CompanyPages = 0,
  EidsivaNo = 1,
}

export interface PlatformTemplate {
  id: number
  platformType: PlatformType
  eventType: EventType
  text: string
  subject: string
  editableFields: Dictionary<Date | string>
}

export interface PlatformTemplateResult {
  id: number
  platformType: PlatformType
  eventType: EventType
  text: string
  editedText: string
  subject: string
  editedSubject: string
  editableFields: Dictionary<Date | string>
}

export interface ExternalPlatformMessage {
  template: PlatformTemplateResult
  isVisible: boolean
}

export interface ExternalPlatformMessagePayload {
  message: PlatformTemplateResult
  messageIsExternallyVisible: boolean
}

export enum PlatformEventType {
  Generell,
  Planlagt,
  Fellesfeil,
}
